import { render, staticRenderFns } from "./BackHeader.vue?vue&type=template&id=2f4e5504&"
import script from "./BackHeader.vue?vue&type=script&lang=js&"
export * from "./BackHeader.vue?vue&type=script&lang=js&"
import style0 from "./BackHeader.vue?vue&type=style&index=0&id=2f4e5504&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports